import { normalizeLocale } from './locales.mjs'

function validDate(value) {
  const date = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(date.getTime())) throw new RangeError('Invalid date value')
  return date
}

export function formatLocaleDate(value, locale, options = {}) {
  return new Intl.DateTimeFormat(normalizeLocale(locale), options).format(validDate(value))
}

export function formatLocaleDateTime(value, locale, options = {}) {
  return new Intl.DateTimeFormat(normalizeLocale(locale), {
    dateStyle: 'medium',
    timeStyle: 'short',
    ...options,
  }).format(validDate(value))
}

export function formatLocaleNumber(value, locale, options = {}) {
  return new Intl.NumberFormat(normalizeLocale(locale), options).format(value)
}
